import React, {Component, useEffect} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useHistory } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { Image } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import {_axios} from '../../plugins/axios';
import TitleHeader from "../common/titleHeader";
import { URL,USER } from "../../constants/constant";
import { Modal } from "react-bootstrap";
import axios from "axios";

const validMobileRegex = RegExp(/^[6-9]\d{9}$/i);

const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
      (val) => val.length > 0 && (valid = false)
    );
    return valid;
  }

class OTPCustomer extends Component{
  constructor(props){
    super(props);
    console.log(this.props);
    this.state = {
        otpVerificationCheck : true, 
        sendOTP : false,
        verifyOTP : false,
        phoneNumber: localStorage.getItem('customer_phoneNumber') ? JSON.parse(localStorage.getItem('customer_phoneNumber')) : '',
        otp: null,
        otpDataId : null,
        showMessage : null,
        errors: {
          phoneNumber: ''
        },
        skipState: false,
        relatedOrders: [],
        relatedOrdersModal: false,
        currentOrder: [],
        userdata: USER.user,
        isLoaded: false
    }
  }

  async getOrders(){
    try {
      let currOrderId = parseInt(this.props.match.params.orderId)
      let url = URL.dev_url;
      let route = url + 'getorders'
      let obj = {
          phleboId: this.state.userdata.phleboId,
      }
      const response = await _axios.post(route, obj)
      const currentOrder = response.data.sampleTakenOrders.filter(data => data.orderId == currOrderId)
      let dependantId = currentOrder[0].dependantId
      let relatedOrders = response.data.sampleTakenOrders.filter(data => data.dependantId == dependantId && data.orderStatus.currentStatusId == 5)
      relatedOrders = relatedOrders.map(data =>{
        data.isSelected = true
        return data
      })
      this.setState({ relatedOrders: relatedOrders })
    } catch (error) {
      console.log(error)
    }
  }

  async componentDidMount () {
    await this.getOrders()
    this.setState({
      isLoaded: true,
      skipState : !["Mysuru", "Kochi", "Visakhapatnam", "Jaipur"].includes(this.state.userdata.city)
    })
  }

  removeLocalStorage(){
    localStorage.removeItem('customer_phoneNumber');
    localStorage.removeItem('upsellMemberDetailsConfirm');
    localStorage.removeItem('orderTestDetails');
    localStorage.removeItem('upsellOrderIds');
    localStorage.removeItem('order_details');
    localStorage.removeItem('order_details');
    localStorage.removeItem('phlebo_start_order_trip_details');
    localStorage.removeItem('AppointmentDate');
    localStorage.removeItem('AppointmentId');
    localStorage.removeItem('City');
    localStorage.removeItem('DID');
    USER.orderDetails = null;
  }

  skipOTP(){
    this.props.history.push('/orders/pending');
    this.removeLocalStorage();
    // this.setState({ relatedOrdersModal: true })
  }
 

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case 'phoneNumber': 
        errors.phoneNumber = 
        validMobileRegex.test(value)
            ? this.setState({ phoneNumber : value})
            : 'Phone Number must be valid';
        break;
      default:
        break;
    }

    this.setState({errors, [name]: value});
  }


  sendOTP(){
    let that = this;
    console.log(this.state)
    const url = URL.dev_url;
    _axios.post(`${url}sendOTPForUsers`,{phonenumber : this.state.phoneNumber.toString(), type: "OTP_Validation"})
    .then(function (response) {
        console.log(response.data);
        that.setState({
            sendOTP : response.data.success,
            otpDataId : response.data.otpDataId,
            showMessage : null
        })
    }).catch(function (error) {
        console.log(error);
      })
  }

  verifyOtp(event){
     const { name, value } = event.target;
     if(value.length == 4){
         this.setState({
             otp : value
         })
     }else{
         console.log("otp..",value)
     }
  }

  handleSubmit = (event) => {
    event.preventDefault();

    if(this.state.relatedOrders.length > 1){
      this.setState({ relatedOrdersModal: true })
    } else {
      let that = this;
      let url = URL.dev_url;
      let route = url + 'verifyotp';
  
      _axios.post(route,{phonenumber : this.state.phoneNumber, otp: this.state.otp, otpEvent:'customer', otpDataId : this.state.otpDataId ? this.state.otpDataId : null ,orderId: parseInt(this.props.match.params.orderId)})
          .then(function (response) {
            if(response.data.otpStatus){
              that.setState({
                showMessage : null
              },()=>{
                that.removeLocalStorage();
                that.props.history.push('/orders');
              })
            }else if(!response.data.otpStatus){
              that.setState({
                showMessage : "Invalid OTP !"
              })
            }
          }).catch(function (error) {
              console.log(error);
          })
    }

    
  }

  routeToSampleDetails () {
    // let orderId = localStorage.getItem("orderId");
    this.props.history.push(`/sample/collectedCompleted/${this.props.match.params.orderId}`)
  }

  markBulkSkipOTPupdate(id,e){
    const relatedOrders = this.state.relatedOrders
    for(let data of relatedOrders){
        if(data.orderId == id){
            data.isSelected = !data.isSelected
            break
        }
    }
    this.setState({ relatedOrders: relatedOrders })
  }

  updateSkipOTPOrderBulk(){
    this.props.history.push('/orders/pending');
    this.removeLocalStorage();
  }

  async updateBulkSkipOTPUpdate(){
    try {
      let relatedOrders = this.state.relatedOrders
      let bulkOrderIds = []
      for(let order of relatedOrders){
        if(!order.isSelected) continue
        bulkOrderIds.push(order.orderId)
      }
      let url = URL.dev_url;
      let route = url + 'verifyotp';
      let response = await _axios.post(route,{phonenumber : this.state.phoneNumber, otp: this.state.otp, otpEvent:'customer', otpDataId : this.state.otpDataId ? this.state.otpDataId : null, bulkOrderIds: bulkOrderIds})
        if(!response.data.otpStatus){
          this.setState({
            showMessage : "Invalid OTP !"
          })
          throw new Error("Invalid OTP")
        }
      this.setState({
        showMessage : null
      },()=>{
        this.removeLocalStorage();
        this.props.history.push('/orders');
      })
    } catch (error) {
      this.setState({
        showMessage : "Something went Wrong!!!"
      })
    }
    
  }


  render(){
    const {errors} = this.state;
    return(
        this.state.isLoaded ? <div  className="order-details-dashboard">
            <div>
            <TitleHeader title="ENTER OTP" subtitle="Otp has been sent to Customer's Phone" secondsubtitle="Please Enter 4 digit OTP"></TitleHeader>
            </div>
            <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.relatedOrdersModal}
                    onHide={() => {this.setState({relatedOrdersModal : false})}}
                    >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update other tests as well for this customer ({this.state?.orderDetails?.pendingOrders?.[0]?.patientDetails?.[0]?.name})?
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{padding:'1px', overflowY: "auto",display: "flex", flexDirection: "column", rowGap: "1px", marginTop: "5px"}}>
                        <Row style={{"display": "flex", "flexDirection": "column", "marginLeft": "20px"}}>
                            {this.state.relatedOrders.map(data => (
                                 data.orderId != parseInt(this.props.match.params.orderId) && <div style={{display: "flex"}}>
                                    <input
                                        type="checkbox"
                                        id={data.id}
                                        name={data.id}
                                        onChange={(e) => this.markBulkSkipOTPupdate(data.orderId, e)}
                                        checked={data.isSelected}
                                    />
                                    <label style={{marginLeft: "5px"}} for={data.id}>{`${data.tests[0].testName} (# ${data.appointmentId})`}</label>
                                </div> 
                                
                            ))}
                        </Row>
                            
                        
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.state.otp ? this.updateBulkSkipOTPUpdate() : this.updateSkipOTPOrderBulk()}>Save changes</Button>
                    </Modal.Footer>
                </Modal>
           
                <Container>

                    <Row className="m-t-50">
                        <Col xs={12} md={12}>
                            <Form onSubmit={(e)=>this.handleSubmit(e)}>

                                   <Form.Group>
                                        <Form.Label htmlFor="phoneNumber">Phone Number</Form.Label>
                                        <Form.Control type="number" name='phoneNumber' value={this.state.phoneNumber} disabled= {true} placeholder="Enter Phone Number" onChange={(e)=>this.handleChange(e)} />
                                        {errors.phoneNumber && 
                                        <span className='font-size-sm gray-color'>{errors.phoneNumber}</span>}
                                    </Form.Group>

                                <Form.Group>
                                    <Form.Label htmlFor="otp">OTP</Form.Label>
                                    <Form.Control type="password" name='otp' placeholder="Password" onChange={(e)=>this.verifyOtp(e)}/>
                                
                                </Form.Group>
                                <div className="p-b-10">
                                    {
                                        this.state.sendOTP ? 
                                        <>
                                         <Button variant="primary" type="submit"  className="text-align-center w-100" disabled={errors.phoneNumber} > Verify OTP </Button> 
                                        <div className="text-align-center p-t-10 base-color font-size-smd bold" onClick={(e)=> this.sendOTP(e)} disabled={errors.phoneNumber} >
                                          Resend OTP
                                        </div>
                                        <div className="text-align-center red-color font-size-smd bold p-t-10 ">
                                         {this.state.showMessage}
                                        </div>
                                        </>
                                        : 
                                        <Button variant="primary" type="button" onClick={(e)=> this.sendOTP(e)} disabled={errors.phoneNumber}  className="text-align-center w-100"> Send OTP </Button>
                                    }
                                </div>
                                { this.state.skipState && 
                                <div className="p-b-20">
                                 <Button variant="info" type="submit"  className="text-align-center w-100" onClick={(e)=> this.skipOTP(e)} > SKIP </Button>
                                </div>}
                                
                            </Form>
                         </Col>
                       
                    </Row>
                    
                    <Row>
                        <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
                            <div className="display-flex justify-content-space-between">
                                <Col>
                                    <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => this.routeToSampleDetails()}>Back</button>    
                                </Col>
                            </div>
                        </div>
                    </Row>
                    

                </Container>
        </div>: <>Loading...</>
        )
    }
}
export default OTPCustomer;